const CHROME_SPECIFIC_OPTIONS = {
  chromeSpecificConstraints: {
    mandatory: {
      googCpuOveruseDetection: true,
    },
  },
}

const DESKTOP_BROWSER_CONNECT_OPTIONS = {
  bandwidthProfile: {
    video: {
      mode: 'grid',
      contentPreferencesMode: 'manual',
      clientTrackSwitchOffControl: 'manual',
    },
  },
  // Wide-band speech recommended bit range of 16 to 20 kbps
  maxAudioBitrate: 20480, // For music remove this line
  preferredVideoCodecs: 'auto',
  networkQuality: { local: 5, remote: 5 },
  ...CHROME_SPECIFIC_OPTIONS,
}

const MOBILE_BROWSER_CONNECT_OPTIONS = {
  bandwidthProfile: {
    video: {
      mode: 'grid',
      maxSubscriptionBitrate: 2500000,
      contentPreferencesMode: 'auto',
      clientTrackSwitchOffControl: 'auto',
    },
  },
  // Wide-band speech recommended bit range of 16 to 20 kbps
  maxAudioBitrate: 20480, // For music remove this line
  /* in devices with restricted CPU or battery life we recommend setting maxVideoBitrate
  to a value between 500000 and 2000000 bps per track. */
  // maxVideoBitrate: 2000000,
  preferredVideoCodecs: 'auto',
  networkQuality: { local: 5, remote: 5 },
  ...CHROME_SPECIFIC_OPTIONS,
}

/* iOS devices have HW support for H.264; hardware acceleration which optimises battery life
VP8 and H.264 multi-codec rooms are supported
In Group Rooms, support for H.264 video is currently limited to the Constrained Baseline profile at level 3.1.
This means that the maximum resolution of a video track is 1280x720 at 30 fps. */
const IOS_CONNECT_OPTIONS = {
  // preferredVideoCodecs: ['H264'],
}

export const CAMERA_VIDEO_NAME = 'camera'
export const SCREEN_SHARE_VIDEO_NAME = 'screenShare'

const DESKTOP_CAM_OPTIONS = {
  height: 720,
  width: 1280,
  frameRate: 30,
}

const MOBILE_CAM_OPTIONS = {
  height: 720,
  frameRate: 30,
  width: 1280,
}

const MOBILE_WITH_HW_SUPPORT_CAM_OPTIONS = {
  height: 720,
  width: 1280,
  frameRate: 30,
}

const SCREEN_SHARE_OPTIONS = {
  height: 1080,
  width: 1920,
  frameRate: 30,
}

const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent)

export const getConnectionOptions = () => {
  let options
  if (isMobile) {
    options = MOBILE_BROWSER_CONNECT_OPTIONS
    if (isIOS) {
      options = {
        ...options,
        ...IOS_CONNECT_OPTIONS,
      }
    }
  } else {
    options = DESKTOP_BROWSER_CONNECT_OPTIONS
  }
  return options
}

export const getCamOptions = () => {
  let otherOptions
  if (isMobile) {
    // TODO: detect HW support for H264 or VP8 on android
    if (isIOS) {
      otherOptions = MOBILE_WITH_HW_SUPPORT_CAM_OPTIONS
    } else {
      otherOptions = MOBILE_CAM_OPTIONS
    }
  } else {
    otherOptions = DESKTOP_CAM_OPTIONS
  }

  /* this hash is a temporary fix for a race condition between unpublish and publish in twilio SDK
  see https://github.com/twilio/twilio-video.js/issues/1227 for more details
  once this issue is resolved, the hash can be deleted */
  const hash = Math.random().toString(36).substr(2, 5)
  return {
    name: `${CAMERA_VIDEO_NAME}-${hash}`,
    ...otherOptions,
  }
}

export const getScreenShareOptions = () => {
  return SCREEN_SHARE_OPTIONS
}
